import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-video-progress',
  templateUrl: './video-progress.component.html',
  styleUrls: ['./video-progress.component.css'],
  standalone: false
})
export class VideoProgressComponent implements OnInit {
  @ViewChild('video') video!: ElementRef<HTMLVideoElement>;
  @ViewChild('progressBar') progressBar!: ElementRef<HTMLProgressElement>;
  progressText: string = '0%';
  videoUrl: string = 'https://nvr-proxy.pro-vigil.us/nvr/api/pro/NAS1/729807/nvr_stream_video_buffer/729807/729807CAM1729083015/2024-11-15/09/2024-11-15-09-49-59.mp4?autoplay=1&mute';

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.loadVideo();
  }

  private loadVideo(): void {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', this.videoUrl, true);
    xhr.responseType = 'blob';

    xhr.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = (event.loaded / event.total) * 100;
        this.updateProgress(percent);
      }
    };

    xhr.onload = () => {
      const videoBlob = xhr.response;
      const videoUrl = URL.createObjectURL(videoBlob);
      this.video.nativeElement.src = videoUrl;
    };

    xhr.onerror = () => {
      console.error('Download failed.');
    };

    xhr.send();
  }

  private updateProgress(percent: number): void {
    this.progressBar.nativeElement.value = percent;
    this.progressText = `${Math.round(percent)}%`;
  }
}
